import { createFileRoute, redirect } from '@tanstack/react-router'
import Layout from '../components/Layout'

export const Route = createFileRoute('/')({
    component: Layout,
    beforeLoad: async ({ context }) => {
        let shouldRedirect = false

        if (context.auth.status === 'PENDING') {
            try {
                await context.auth.ensureData()
            }
            catch {
                shouldRedirect = true
            }
        }

        if (context.auth.status === 'UNAUTHENTICATED') {
            shouldRedirect = true
        }

        if (shouldRedirect) {
            throw redirect({
                to: '/sign-in'
            })
        }
    },
})